import { t } from 'i18next'
import { currencyStore } from '../../localization/currency'
import { mapPeriodToBackend } from './calculateFinalPrice'
import {
  generateTariffLink,
  onIpSwitch,
  onPeriodSwitch,
  rewritePrices,
  toggleDropdown,
} from './cloud_methods'
import Swiper from 'swiper'
import { DC_DICTIONARY } from '../../constants'
import { debounce } from '../../debounce'
import { switchRadioUI } from '../../utils/switchRadioUi'
import { getKeyByValue } from '../../utils'
import {
  updateLocationFilter,
  updatePeriodFilter,
  updateIpTypeFilter,
} from '../vds_comparison/filter'

const store = {
  ipPrice: 0,
  location: '',
  period: 30,
  ipType: 'ipv4',
}

const MOBILE_BREAKPOINT = 768

const allTariffs = window.tariffsData?.tariffs

const currencyData = currencyStore.getSelectedCurr()

let packages = document.querySelectorAll('[data-cloud-tariff]')
let swiperInstance = null

const locationSelectId = 'dc-select'
const cpuSelectId = 'cpu-select'

const priceDescriptionElems = document.querySelectorAll('[data-cloud-price-description]')
let oldPriceElms = document.querySelectorAll('[data-old-price]')
let comparisonPriceBlock = document.querySelectorAll('.comparison__tariff-price')
const overlay = document.querySelector('[data-cookie-overlay]')
const soldOutModal = document.querySelector('[data-sold-out-modal]')
const closeBtn = document.querySelector('[data-close-sold-out-modal]')
let packagesLinks = document.querySelectorAll('[data-cloud-link]')
const mobileTariffsSwiperList = document.querySelector('[data-cloud-swiper-list]')
const desktopTariffsTableBody = document.querySelector('[data-cloud-tariffs-table-body]')
const locationSelect = document.getElementById(locationSelectId)
const isComparisonPage = document.querySelector('[data-vds-tbody-comparsion]')

if (locationSelect) {
  store.location = locationSelect.dataset.location
}
let currentListeners = null

currencyStore.subscribe(() => {
  packages = document.querySelectorAll('[data-cloud-tariff]')
  rewritePrices(packages, store)
})

document.addEventListener('DOMContentLoaded', () => {
  initSwiper()

  // only for comparison page
  if (isComparisonPage) {
    hideItems()
    const datacenterKey = getKeyByValue(DC_DICTIONARY, store.location)
    updateLocationFilter(datacenterKey)
    updatePeriodFilter(store.period)
    updateIpTypeFilter(store.ipType)
  }
})

const debouncedResize = debounce(() => {
  initSwiper()
  const location = Object.keys(DC_DICTIONARY).find(
    loc => DC_DICTIONARY[loc] === store.location,
  )
  const currentDcTariffs = allTariffs?.[location] || []
  if (desktopTariffsTableBody?.closest('[data-tariff-table-js-fill]')) {
    renderItems(currentDcTariffs)
  }
}, 250)

window.addEventListener('resize', debouncedResize)

document.addEventListener('click', e => {
  packages = document.querySelectorAll('[data-cloud-tariff]')

  if (e.target.dataset.ipBtn !== undefined) {
    updateAllElements()

    const isIpv6 =
      e.target.textContent.toLowerCase().includes('ipv6') ||
      e.target.classList.contains('ipv6') ||
      e.target.dataset.ipType === 'ipv6'

    store.ipType = isIpv6 ? 'ipv6' : 'ipv4'

    onIpSwitch({
      packages,
      packagesLinks,
      store,
      comparisonPriceBlock,
      oldPriceElms,
      elm: e.target,
    })

    if (isComparisonPage) {
      updateIpTypeFilter(store.ipType)
    }
  }

  if (e.target.dataset.period !== undefined) {
    store.period = parseInt(e.target.dataset.period) || 30

    onPeriodSwitch({ packages, store, elm: e.target })

    if (isComparisonPage) {
      updatePeriodFilter(store.period)
    }
  }

  if (e.target.closest('[data-dc-option]')) {
    onDcSwitch({ packages, store, elm: e.target.closest('[data-dc-option]') })
  }

  if (e.target.closest('[data-sold-out-btn]')) {
    overlay.classList.add('opened')
    soldOutModal.classList.add('opened')
  }

  if (
    e.target.id === locationSelectId ||
    e.target.id === cpuSelectId ||
    e.target.dataset.periodSelect !== undefined
  ) {
    openDropdown(e)
  }
})

function isMobile() {
  return window.innerWidth < MOBILE_BREAKPOINT
}

function initSwiper() {
  let swiperEl = document.querySelector('[data-cloud-tariffs-swiper]')
  if (swiperInstance && swiperEl) {
    swiperInstance.destroy(true, true)
  }

  if (isMobile()) {
    swiperInstance = new Swiper('[data-cloud-tariffs-swiper]', {
      slidesPerView: 'auto',
      pagination: {
        el: '[data-cloud-tariffs-progress-bar]',
        type: 'progressbar',
      },
      navigation: {
        nextEl: '[data-cloud-tariffs-next]',
        prevEl: '[data-cloud-tariffs-prev]',
      },
    })
  }
}

function updateAllElements() {
  packages = document.querySelectorAll('[data-cloud-tariff]')
  packagesLinks = document.querySelectorAll('[data-cloud-link]')
  oldPriceElms = document.querySelectorAll('[data-old-price]')
  comparisonPriceBlock = document.querySelectorAll('.comparison__tariff-price')
}

closeBtn?.addEventListener('click', () => {
  overlay.classList.remove('opened')
  soldOutModal.classList.remove('opened')
})

priceDescriptionElems?.forEach(btn =>
  btn?.addEventListener('click', () => {
    btn?.classList.toggle('opened')
  }),
)

function setLocation({ selectEl, chevronIcon, label }) {
  const fragment = document.createDocumentFragment()
  if (selectEl.firstElementChild) {
    fragment.append(selectEl.firstElementChild)
  }
  fragment.append(document.createTextNode(label))
  if (chevronIcon) {
    fragment.append(chevronIcon)
  }
  selectEl.innerHTML = ''
  selectEl.append(fragment)
}

function openDropdown(event) {
  const selectEl = event.target
  const optnsContainer = selectEl?.nextElementSibling
  const chevronIcon = selectEl?.querySelector('[data-chevron-icon]')

  if (!optnsContainer || !chevronIcon) return

  const isOpen = optnsContainer.classList.contains('opened')

  cleanupListeners()

  if (isOpen) {
    toggleDropdown({ optnsContainer, chevronIcon, selectEl })
    return
  }

  closeAllDropdowns()

  toggleDropdown({ optnsContainer, chevronIcon, selectEl })

  function documentClickHandler(e) {
    const target = e.target
    const insideClick = target === optnsContainer || optnsContainer.contains(target)
    const clickOnSelect = target === selectEl || selectEl.contains(target)
    const menuIsOpen = optnsContainer.classList.contains('opened')

    if (!insideClick && !clickOnSelect && menuIsOpen) {
      toggleDropdown({ optnsContainer, chevronIcon, selectEl })
      cleanupListeners()
    }
  }

  function onOptionClick(e) {
    if (!e.target.hasAttribute('data-label')) return

    const label = e.target.getAttribute('data-label')
    if (!label) return

    const parentSelectEl = e.target?.closest('[data-select-wrapper]')?.querySelector('.select')

    if (!parentSelectEl) return

    setLocation({ selectEl, chevronIcon, label })
    toggleDropdown({ optnsContainer, chevronIcon, selectEl })

    updateAllElements()
    generateTariffLink({ packagesLinks, store })

    if (e.target.dataset.dcOption !== undefined) {
      const currentDcTariffs = allTariffs?.[e.target.dataset.label]
      store.location = DC_DICTIONARY?.[e.target.dataset.label]
      renderItems(currentDcTariffs)
    }

    if (e.target.dataset.period !== undefined) {
      store.period = parseInt(e.target.dataset.period) || 30
      if (isComparisonPage) {
        updatePeriodFilter(store.period)
      }
    }

    cleanupListeners()
  }

  document.addEventListener('click', documentClickHandler)
  optnsContainer.addEventListener('click', onOptionClick)

  currentListeners = {
    documentHandler: documentClickHandler,
    optionHandler: onOptionClick,
    container: optnsContainer,
  }
}

function onDcSwitch({ store, elm }) {
  const label = elm.getAttribute('data-label')
  if (!label) return

  const dcName = elm.getAttribute('data-dc-name')
  if (!dcName) return
  const chevronIcon = null

  switchRadioUI({ elm, attribute: '[data-dc-option]' })
  setLocation({ selectEl: elm, chevronIcon, label })
  updateAllElements()
  generateTariffLink({ packagesLinks, store })

  const currentDcTariffs = allTariffs?.[dcName]
  store.location = DC_DICTIONARY?.[dcName]

  if (currentDcTariffs) {
    renderItems(currentDcTariffs)
  }

  if (isComparisonPage) {
    hideItems()
    const datacenterKey = getKeyByValue(DC_DICTIONARY, store.location)
    updateLocationFilter(datacenterKey)
  }
}

function hideItems() {
  const visibleIds = allTariffs
    .filter(tariff => tariff.datacenter === getKeyByValue(DC_DICTIONARY, store.location))
    .map(tariff => tariff.id)

  allTariffs.forEach(tariff => {
    const element = document.getElementById(tariff.id)
    if (element) {
      element
        .closest('.cloud__table-row')
        ?.classList?.toggle('hidden-dc', !visibleIds.includes(tariff.id))
    }
  })
}

function renderItems(currentDcTariffs) {
  if (locationSelect) {
    locationSelect.dataset.location = store.location
  }

  if (isMobile()) {
    const currentDcTariffsMarkup = currentDcTariffs
      .map(tariff => tariffCardMarkup(tariff))
      .join('')

    if (mobileTariffsSwiperList) {
      mobileTariffsSwiperList.innerHTML = currentDcTariffsMarkup

      initSwiper()
    }
  } else {
    const currentDcTariffsMarkup = currentDcTariffs
      .map(tariff => tariffTableMarkup(tariff))
      .join('')

    if (desktopTariffsTableBody) {
      desktopTariffsTableBody.innerHTML = currentDcTariffsMarkup
    }
  }

  updateAllElements()

  rewritePrices(packages, store)

  generateTariffLink({ packagesLinks, store })

  if (store.ipPrice !== 0) {
    comparisonPriceBlock?.forEach(price => price?.classList?.add('with_sale'))
    oldPriceElms.forEach(el => (el.style.display = 'block'))
  } else {
    comparisonPriceBlock?.forEach(price => price?.classList?.remove('with_sale'))
    oldPriceElms.forEach(el => (el.style.display = 'none'))
  }
}

function cleanupListeners() {
  if (currentListeners) {
    document.removeEventListener('click', currentListeners.documentHandler)
    currentListeners.container.removeEventListener('click', currentListeners.optionHandler)
    currentListeners = null
  }
}

function closeAllDropdowns() {
  const openDropdowns = document.querySelectorAll('.select.opened')

  openDropdowns.forEach(selectEl => {
    const optnsContainer = selectEl.nextElementSibling
    const chevronIcon = selectEl.querySelector('[data-chevron-icon]')

    if (optnsContainer?.classList.contains('opened')) {
      toggleDropdown({ optnsContainer, chevronIcon, selectEl })
    }
  })
}

function tariffTableMarkup(tariff, isHidden = false) {
  return `<tr class="cloud__table-row ${tariff.limited ? 'limited' : ''} ${
    isHidden ? 'hidden' : ''
  }" data-cloud-tariff="${tariff.name}">
  <td class="${tariff.limited ? 'limited' : ''}">
    ${
      tariff.limited
        ? `
      <span class="cloud_limited_label">Limited time!</span>
      <span class="cloud_limite_pointer"></span>
      <span class="cloud_limite_time">24.07 - 26.07</span>
    `
        : ''
    }
    <p class="h6">${tariff.name}</p>
  </td>
  <td>${parseFloat(tariff.cpu_count)}</td>
  <td>${parseFloat(tariff.ram)}</td>
  <td>${parseFloat(tariff.disk)}</td>
  <td>${tariff.os?.replace('\\u0026', '&')}</td>
  <td class="cloud__table-os-td">
    ${
      tariff.discount_price != null
        ? `
      <div class="cloud__table-price-wrapper" data-has-discount>
        <div class="cloud__table-main-price-wrapper">
          <span
            class="h6 cloud__tariff-old-price-discount"
            data-ipv4-price="${tariff.day_no_discount_price_ipv4}"
            data-ipv6-price="${tariff.day_no_discount_price_ipv6}"
          >
            ${tariff.month_no_discount_price.toFixed(2)}${currencyData?.symbol}
          </span>
          <span
            class="pink_text_gradient h6"
            data-ipv4-discount-price="${tariff.day_discount_price_ipv4}"
            data-ipv6-discount-price="${tariff.day_discount_price_ipv6}"
          >
            ${Math.round(tariff.month_discount_price * 100) / 100}${currencyData?.symbol}
          </span>
        </div>
        <div class="promo_label upper_xs">${t('cloud_trial_label')}</div>
      </div>
    `
        : `
      <div class="cloud__table-price-wrapper">
        <div class="cloud__table-main-price-wrapper">
          <span class="cloud__tariff-old-price" data-old-price>
            ${tariff.day_no_discount_price}${currencyData?.symbol}
          </span>
          <span
            class="pink_text_gradient h6"
            data-ipv4-price="${tariff.day_no_discount_price_ipv4}"
            data-ipv6-price="${tariff.day_no_discount_price_ipv6}"
          >
            ${Math.round(tariff.month_no_discount_price * 100) / 100}${currencyData?.symbol}
          </span>
        </div>
        <div class="promo_label upper_xs">${t('cloud_trial_label')}</div>
      </div>
    `
    }
  </td>
  <td>
    <div class="cloud__table-buy-block">
      ${
        !tariff.available_for_buy
          ? `<div class="warning_icon popup_trigger"><svg viewBox="0 0 32 32" fill="none" height="32" width="32" xmlns="http://www.w3.org/2000/svg"><path d="M30.9318 26.7962L17.8519 3.53221C17.0254 2.06218 14.959 2.06218 14.1325 3.53221L1.05261 26.7962C0.226107 28.2662 1.25923 30.1038 2.91226 30.1038H29.0721C30.7252 30.1038 31.7583 28.2662 30.9318 26.7962ZM14.6195 11.4179C15.0032 10.9574 15.4909 10.727 16.086 10.727C16.6813 10.727 17.1688 10.955 17.5528 11.4087C17.9342 11.8636 18.125 12.4324 18.125 13.1164C18.125 13.7047 17.3284 18.0321 17.063 21.1803H15.1442C14.9111 18.0322 14.0469 13.7048 14.0469 13.1164C14.047 12.4428 14.2381 11.8763 14.6195 11.4179ZM17.5256 26.3874C17.1221 26.8238 16.6419 27.0414 16.086 27.0414C15.5304 27.0414 15.0499 26.8238 14.6465 26.3874C14.244 25.9521 14.0439 25.4247 14.0439 24.8052C14.0439 24.1892 14.244 23.656 14.6465 23.2092C15.0499 22.7624 15.5304 22.5391 16.086 22.5391C16.6419 22.5391 17.1222 22.7625 17.5256 23.2092C17.928 23.656 18.1285 24.1891 18.1285 24.8052C18.1285 25.4248 17.928 25.9522 17.5256 26.3874Z" fill="#F79649"></path></svg><div class="small_text popup_block"><div><svg viewBox="0 0 32 32" fill="none" height="32" width="32" xmlns="http://www.w3.org/2000/svg"><path d="M30.9318 26.7962L17.8519 3.53221C17.0254 2.06218 14.959 2.06218 14.1325 3.53221L1.05261 26.7962C0.226107 28.2662 1.25923 30.1038 2.91226 30.1038H29.0721C30.7252 30.1038 31.7583 28.2662 30.9318 26.7962ZM14.6195 11.4179C15.0032 10.9574 15.4909 10.727 16.086 10.727C16.6813 10.727 17.1688 10.955 17.5528 11.4087C17.9342 11.8636 18.125 12.4324 18.125 13.1164C18.125 13.7047 17.3284 18.0321 17.063 21.1803H15.1442C14.9111 18.0322 14.0469 13.7048 14.0469 13.1164C14.047 12.4428 14.2381 11.8763 14.6195 11.4179ZM17.5256 26.3874C17.1221 26.8238 16.6419 27.0414 16.086 27.0414C15.5304 27.0414 15.0499 26.8238 14.6465 26.3874C14.244 25.9521 14.0439 25.4247 14.0439 24.8052C14.0439 24.1892 14.244 23.656 14.6465 23.2092C15.0499 22.7624 15.5304 22.5391 16.086 22.5391C16.6419 22.5391 17.1222 22.7625 17.5256 23.2092C17.928 23.656 18.1285 24.1891 18.1285 24.8052C18.1285 25.4248 17.928 25.9522 17.5256 26.3874Z" fill="#F79649"></path></svg></div><div class="cloud__popup-text-block"><p class="title_tooltip">${t(
              'sold_out_title',
            )}</p><p class="tooltip_text">${t(
              'sold_out_text',
            )}</p></div><div class="pointer"></div></div></div>`
          : ''
      }
      
<a class="doubleButton_wrapper buy_btn" id="Starter AMD" rel="nofollow noindex noopener" data-cloud-link="" href="${
    process.env.BILLING_URL_FRONTEND || 'https://billing.example.com/'
  }site_cart?func=v2.instances.order.param&name=${encodeURIComponent(tariff.name)}&location=${
    store.location
  }&cpu=${tariff.cpu_type.toLowerCase()}&category=${
    tariff.category
  }&type=${tariff.type.toLowerCase()}&period=${mapPeriodToBackend(
    store.period,
  )}"> <div class="btn_primary_text doubleButton_main"><span>${t(
    'step_1_btn',
  )}</span></div> <div class="round_btn"><svg viewBox="0 0 24 24" fill="none" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M15.998 9V6a4 4 0 1 0-8 0v3M3.59 10.352l-.6 6.4c-.17 1.82-.255 2.73.046 3.432a3 3 0 0 0 1.32 1.45C5.028 22 5.942 22 7.77 22h8.458c1.828 0 2.742 0 3.413-.366a3 3 0 0 0 1.32-1.45c.302-.703.217-1.612.046-3.432l-.6-6.4c-.144-1.537-.216-2.305-.561-2.886a3 3 0 0 0-1.292-1.176C17.943 6 17.171 6 15.627 6H8.37c-1.543 0-2.315 0-2.925.29a3 3 0 0 0-1.292 1.176c-.345.581-.418 1.35-.562 2.886" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></svg></div> </a>
    </div>
  </td>
</tr>
`
}

function tariffCardMarkup(tariff, isHidden = false) {
  return `<li class="cloud__tariff-item swiper-slide ${tariff.limited ? 'limited' : ''} ${
    isHidden ? 'hidden' : ''
  }" data-cloud-tariff="${tariff.name}">
  <div class="">
    <p class="h5">${tariff.name}</p>

    ${
      tariff.limited
        ? `
      <span class="cloud_limited_label">Limited time!</span>
      <span class="cloud_limite_pointer"></span>
      <span class="cloud_limite_time">24.07 - 26.07</span>
    `
        : ''
    }
  </div>

  <ul class="cloud__tariff-params body_s">
    <li class="cloud__tariff-params-row">
      <span class="cloud__tariff-param-label">vCPU</span>
      ${parseFloat(tariff.cpu_count)}
    </li>
    <li class="cloud__tariff-params-row">
      <span class="cloud__tariff-param-label">RAM</span>
      ${parseFloat(tariff.ram)}
    </li>
    <li class="cloud__tariff-params-row">
      <span class="cloud__tariff-param-label">NVMe</span>
      ${parseFloat(tariff.disk)}
    </li>
    <li class="cloud__tariff-params-row">
      <span class="cloud__tariff-param-label">OS</span>
      ${tariff.os?.replace('\\u0026', '&')}
    </li>
  </ul>
  
  ${
    tariff.discount_price != null
      ? `
    <div class="cloud__tariff-price-wrapper" data-has-discount>
      <span
        class="cloud__tariff-old-price-discount"
        data-ipv4-price="${tariff.day_no_discount_price_ipv4}"
        data-ipv6-price="${tariff.day_no_discount_price_ipv6}"
      >
        ${tariff.month_no_discount_price.toFixed(2)}${currencyData?.symbol}
      </span>
      <span
        class="pink_text_gradient h5"
        data-ipv4-discount-price="${tariff.day_discount_price_ipv4}"
        data-ipv6-discount-price="${tariff.day_discount_price_ipv6}"
      >
        ${Math.round(tariff.month_discount_price * 100) / 100}${currencyData?.symbol}
      </span>
      <div class="promo_label upper_xs">${t('cloud_trial_label')}</div>
    </div>
  `
      : `
    <div class="cloud__tariff-price-wrapper">
      <span class="cloud__tariff-old-price" data-old-price>
        ${tariff.day_no_discount_price}${currencyData?.symbol}
      </span>
      <span
        class="pink_text_gradient h6"
        data-ipv4-price="${tariff.day_no_discount_price_ipv4}"
        data-ipv6-price="${tariff.day_no_discount_price_ipv6}"
      >
        ${Math.round(tariff.month_no_discount_price * 100) / 100}${currencyData?.symbol}
      </span>
      <div class="promo_label upper_xs">${t('cloud_trial_label')}</div>
    </div>
  `
  }

  <div class="cloud__tariff-buy-wrapper">
    ${
      !tariff.available_for_buy
        ? '<button data-sold-out-btn><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.9318 26.7962L17.8519 3.53221C17.0254 2.06218 14.959 2.06218 14.1325 3.53221L1.05261 26.7962C0.226107 28.2662 1.25923 30.1038 2.91226 30.1038H29.0721C30.7252 30.1038 31.7583 28.2662 30.9318 26.7962ZM14.6195 11.4179C15.0032 10.9574 15.4909 10.727 16.086 10.727C16.6813 10.727 17.1688 10.955 17.5528 11.4087C17.9342 11.8636 18.125 12.4324 18.125 13.1164C18.125 13.7047 17.3284 18.0321 17.063 21.1803H15.1442C14.9111 18.0322 14.0469 13.7048 14.0469 13.1164C14.047 12.4428 14.2381 11.8763 14.6195 11.4179ZM17.5256 26.3874C17.1221 26.8238 16.6419 27.0414 16.086 27.0414C15.5304 27.0414 15.0499 26.8238 14.6465 26.3874C14.244 25.9521 14.0439 25.4247 14.0439 24.8052C14.0439 24.1892 14.244 23.656 14.6465 23.2092C15.0499 22.7624 15.5304 22.5391 16.086 22.5391C16.6419 22.5391 17.1222 22.7625 17.5256 23.2092C17.928 23.656 18.1285 24.1891 18.1285 24.8052C18.1285 25.4248 17.928 25.9522 17.5256 26.3874Z" fill="#F79649"/></svg></button>'
        : ''
    }

    <a class="doubleButton_wrapper buy_btn" id="${
      tariff.name
    }" rel="nofollow noindex noopener" data-cloud-link="" href="${
    process.env.BILLING_URL_FRONTEND || 'https://billing.example.com/'
  }site_cart?func=v2.instances.order.param&name=${encodeURIComponent(tariff.name)}&location=${
    tariff.datacenter_id
  }&cpu=${tariff.cpu_type.toLowerCase()}&category=${
    tariff.category
  }&type=${tariff.type.toLowerCase()}&period=${mapPeriodToBackend(store.period)}">
      <div class="btn_primary_text doubleButton_main"><span>${t('step_1_btn')}</span></div>
      <div class="round_btn">
        <svg viewBox="0 0 24 24" fill="none" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.998 9V6a4 4 0 1 0-8 0v3M3.59 10.352l-.6 6.4c-.17 1.82-.255 2.73.046 3.432a3 3 0 0 0 1.32 1.45C5.028 22 5.942 22 7.77 22h8.458c1.828 0 2.742 0 3.413-.366a3 3 0 0 0 1.32-1.45c.302-.703.217-1.612.046-3.432l-.6-6.4c-.144-1.537-.216-2.305-.561-2.886a3 3 0 0 0-1.292-1.176C17.943 6 17.171 6 15.627 6H8.37c-1.543 0-2.315 0-2.925.29a3 3 0 0 0-1.292 1.176c-.345.581-.418 1.35-.562 2.886" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>
        </svg>
      </div>
    </a>
  </div>
</li>`
}
